// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-verify-page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
}

.order-verify-page-container h1 {
  display: flex;
  width: 100vw;
  justify-content: center;
  color: #247a97;
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 5rem;
  font-style: italic;
  align-items: center;
}

.order-verify-page-container table {
  border-collapse: collapse;
  width: 100%;
  max-width: 1000px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 1.5rem;
  text-align: center;
}

.order-verify-page-container th {
  font-size: 2.5rem;
}

.order-verify-page-container td {
  font-size: 2rem;
}

.order-verify-page-container .remove-cart-btn {
  font-size: 1.25rem;
  color: #000;
  display: block;
  width: 100%;
  padding: 0.625rem;
  text-align: center;
  border: none;
  border-radius: 15px;
  cursor: pointer;
}

.order-verify-page-container .checkout-billing-btn {
  background-color: #247a97;
  fill: #ffffff;
  color: #ffffff;
  letter-spacing: 0.5px;
  transition: transform 0.3s;
  font-size: 2.5rem;
  font-weight: 600;
  margin-top: 1vh;
  border-radius: 15px;
  border-width: 4px 4px 4px 4px;
  border-style: solid;
  padding: 15px 40px 15px 40px;
  box-shadow: 5px 5px 5px 0px
    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);
}

@media screen and (max-width: 991px) {
  .order-verify-page-container h1 {
    font-size: 5rem;
  }

  .order-verify-page-container th {
    font-size: 4rem;
  }

  .order-verify-page-container tbody {
    text-align: left;
  }

  .order-verify-page-container td {
    font-size: 3rem;
  }

  .order-verify-page-container table tbody tr td:nth-child(2) {
    text-align: center;
  }

  .order-verify-page-container .remove-cart-btn {
    font-size: 2rem;
    padding: 0 1.5rem;
  }

  .order-verify-page-container .checkout-billing-btn {
    font-size: 4.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/OrderVerifyPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B;0DACwD;AAC1D;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".order-verify-page-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 2rem;\n}\n\n.order-verify-page-container h1 {\n  display: flex;\n  width: 100vw;\n  justify-content: center;\n  color: #247a97;\n  font-size: 3rem;\n  font-weight: 900;\n  margin-bottom: 5rem;\n  font-style: italic;\n  align-items: center;\n}\n\n.order-verify-page-container table {\n  border-collapse: collapse;\n  width: 100%;\n  max-width: 1000px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  font-size: 1.5rem;\n  text-align: center;\n}\n\n.order-verify-page-container th {\n  font-size: 2.5rem;\n}\n\n.order-verify-page-container td {\n  font-size: 2rem;\n}\n\n.order-verify-page-container .remove-cart-btn {\n  font-size: 1.25rem;\n  color: #000;\n  display: block;\n  width: 100%;\n  padding: 0.625rem;\n  text-align: center;\n  border: none;\n  border-radius: 15px;\n  cursor: pointer;\n}\n\n.order-verify-page-container .checkout-billing-btn {\n  background-color: #247a97;\n  fill: #ffffff;\n  color: #ffffff;\n  letter-spacing: 0.5px;\n  transition: transform 0.3s;\n  font-size: 2.5rem;\n  font-weight: 600;\n  margin-top: 1vh;\n  border-radius: 15px;\n  border-width: 4px 4px 4px 4px;\n  border-style: solid;\n  padding: 15px 40px 15px 40px;\n  box-shadow: 5px 5px 5px 0px\n    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);\n}\n\n@media screen and (max-width: 991px) {\n  .order-verify-page-container h1 {\n    font-size: 5rem;\n  }\n\n  .order-verify-page-container th {\n    font-size: 4rem;\n  }\n\n  .order-verify-page-container tbody {\n    text-align: left;\n  }\n\n  .order-verify-page-container td {\n    font-size: 3rem;\n  }\n\n  .order-verify-page-container table tbody tr td:nth-child(2) {\n    text-align: center;\n  }\n\n  .order-verify-page-container .remove-cart-btn {\n    font-size: 2rem;\n    padding: 0 1.5rem;\n  }\n\n  .order-verify-page-container .checkout-billing-btn {\n    font-size: 4.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
